import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { RelayEnvironmentProvider } from 'react-relay';
import './index.css';
import App from './App';
import i18n from './services/i18n';
import environment from './services/RelayEnvironment';
import FlashMessage from './components/common/FlashMessage';
import ErrorBoundary from './pages/ErrorBoundary/ErrorBoundary';
import GlobalErrorProvider from './context/GlobalErrorContext';
import { defineCustomElements as defineMapElements } from "@arcgis/map-components/dist/loader";
import config from '@config/config';

defineMapElements(window, { resourcesUrl: config.arcGISResourcesUrl });



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);


// const userPermissions = {
//   "User_Module": ["view"], 
//   // "Admin_Module": ["view"],
// };


root.render(
    <RelayEnvironmentProvider environment={environment}>
      <I18nextProvider i18n={i18n}>
        <ErrorBoundary>
          <GlobalErrorProvider>
              <App />
          </GlobalErrorProvider>
        </ErrorBoundary>
        <FlashMessage />
      </I18nextProvider>
    </RelayEnvironmentProvider>
  ,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
